module.exports = __webpack_public_path__ + "static/c13-581bd2e6c387e5ec07b0881fa125552d.jpg";